import { fromJS } from 'immutable';
import claimMapper from './dataMapper';
import { configClaimCodeMapper, convertClaimCode } from '../FastCover/dataMapper/claimCodeMapper';

import {
  LOAD_CLAIM_LIST_SUCCESS,
  UPDATE_SELECTED_CLAIM_ID,
  PRE_LOAD_CLAIM,
  LOAD_CLAIM_TYPE_SUCCESS,
  LOADING_BUTTON,
  UPDATE_SELECTED_CLAIM_NUMBER,
  GET_TITLE_LIST_SUCCESS,
  UPDATE_SELECTED_CLAIM_NUMBERS,
  GET_DEPRECIATION_TYPE_LIST_SUCCESS,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  claims: [],
  selectedClaimId: 0,
  selectedClaimNumber: '',
  submitted: false,
  claimTypes: [],
  loading: false,
  policyTypeId: '',
  titleList: [],
  selectedClaimNumbers: [],
  depreciationTypes: [],
});

function mapClaimsStatus(claims) {
  if (!claims) {
    return [];
  }
  const translatedClaims = claims.map((claim) => {
    const translatedClaim = claim;
    const translatedStatus = claimMapper.map(claim.status);
    translatedClaim.status = translatedStatus;
    return translatedClaim;
  });

  return translatedClaims;
}

function mapPolicy(policy) {
  const mappedPolicy = policy;
  mappedPolicy.claims = mapClaimsStatus(policy.claims);
  return mappedPolicy;
}

function claimListReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_CLAIM_LIST_SUCCESS:
      return state.set('claims', mapPolicy(action.claims)).set('policyTypeId', action.claims.policyTypeID);
    case UPDATE_SELECTED_CLAIM_ID:
      return state.set('selectedClaimId', action.claimId);
    case UPDATE_SELECTED_CLAIM_NUMBER:
      return state.set('selectedClaimNumber', action.claimNumber);
    case UPDATE_SELECTED_CLAIM_NUMBERS:
      return state.set('selectedClaimNumbers', action.claimNumbers);
    case PRE_LOAD_CLAIM:
      return state.set('submitted', action.submitted);
    case LOAD_CLAIM_TYPE_SUCCESS:
      configClaimCodeMapper(action.claimTypes, state.get('policyTypeId'));
      return state.set('claimTypes', fromJS(convertClaimCode(action.claimTypes, state.get('policyTypeId'))));
    case LOADING_BUTTON:
      return state.set('loading', action.status);
    case GET_TITLE_LIST_SUCCESS:
      return state.setIn(['titleList'], action.titles);
    case GET_DEPRECIATION_TYPE_LIST_SUCCESS:
      return state.setIn(['depreciationTypes'], action.depreciationTypes);
    default:
      return state;
  }
}

export default claimListReducer;



// WEBPACK FOOTER //
// ./app/containers/ClaimList/reducer.js